import { AuthContextValue } from '@shared/components/AuthProvider/AuthProvider.context';
import { ButtonV2, Flex } from '@withjoy/joykit';
import React from 'react';
import { InviteData } from '../hooks/useGetInviteById';
import { useTranslation } from '@shared/core';
import { useChangeAccount } from '../hooks/useChangeAccount';
import { useAcceptCollaborationInvite } from '../hooks/useAcceptCollaborationInvite';

type AcceptInviteProps = {
  eventDisplayName: string;
  eventHandle: string;
  currentUser: AuthContextValue['currentUser'];
  inviteData: InviteData;
};

export const Accept = (props: AcceptInviteProps) => {
  const { currentUser } = props;
  const { tq } = useTranslation('collaboration');
  const { changeAccount } = useChangeAccount();
  const { acceptInvite } = useAcceptCollaborationInvite();

  const handleAccept = async () => {
    if (!props.inviteData) {
      return;
    }
    const result = await acceptInvite(props.inviteData.id);

    // Redirect to event page
    if (result?.event) {
      window.location.href = `/${result.event.id}/edit/dashboard`;
    }
  };

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap="1.5rem"
    >
      <ButtonV2
        intent="primary"
        shape="rounded"
        onClick={handleAccept}
      >{tq`Join as ${currentUser.profile?.email}`}</ButtonV2>
      <ButtonV2
        intent="neutral"
        variant="ghost"
        onClick={changeAccount}
      >
        {tq`Sign out and use another account`}
      </ButtonV2>
    </Flex>
  );
};
